/**
 * Type definitions for the $anythink object available in workflow script execution
 * These types provide IntelliSense support in Monaco Editor
 */

export const ANYTHINK_TYPE_DEFINITIONS = `
/**
 * Type definitions for the $anythink object available in workflow script execution
 */

declare const $anythink: {
  /**
   * The trigger payload that initiated this workflow
   */
  trigger: {
    id?: number;
    entity_name?: string;
    data?: unknown;
  };

  /**
   * Data from previous workflow steps, keyed by step key
   * Each step's output is available under its step key
   */
  steps: Record<string, { data: any }}>;
};
`;
